import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson3DefaultStartCode = `use debug::PrintTrait;
${doNotModifyCodeAbove}`;

export const lesson3DefaultMiddleCode = `//TODO: make this function compile by using a mutable variable
fn main() {
    let x = 3;`;

export const lesson3DefaultEndCode = `    ${doNotModifyCodeBelow}
    x.print();
    x = 5;
    x.print();
}
#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
